<template>
  <div v-show="stageEnabled" :class="$style.field">
    <label :for="id">Current Stage</label>
    <span v-if="readonly" :class="$style.value">{{ value.name }}</span>
    <multiselect
      v-else
      :id="id"
      v-model="value"
      label="name"
      track-by="id"
      placeholder="Please select"
      :allow-empty="!required"
      :show-labels="!required"
      :options="stages"
      select-label=""
      selected-label="✕"
      deselect-label="✕"
    >
      <template #noResult>
        <span>No matches found</span>
      </template>
    </multiselect>
    <p v-show="error && showError">{{ error }}</p>
  </div>
</template>

<script>
import axios from "axios";
import Multiselect from "vue-components/vue-multiselect";
import { createNamespacedHelpers } from "vuex";
import { errorNotification } from "../notifications";

const { mapState, mapGetters, mapMutations } =
  createNamespacedHelpers("activitySummary");

export default {
  components: { Multiselect },
  data() {
    return {
      id: "stage_id",
      value: null,
      stages: [],
      team: this.$_activitySummary_config.getTeam(),
    };
  },
  computed: {
    ...mapGetters(["stageEnabled"]),
    ...mapState([
      "activity",
      "formErrors",
      "selectedProspect",
      "selectedOpportunity",
      "selectedStage",
    ]),
    error() {
      return this.formErrors[this.id];
    },
    required() {
      return !this.activity.isInternal;
    },
    readonly() {
      return ["Opentrons", "Opentrons Lab Services", "kleene.ai"].includes(
        this.team.name
      );
    },
  },
  watch: {
    value(option) {
      this.updateForm(option);
    },
    selectedProspect() {
      this.populateOptions();
    },
    selectedOpportunity() {
      this.populateOptions();
    },
    stageEnabled(value) {
      if (!value) {
        this.reset();
      }
    },
    selectedStage(stage) {
      // Selected stage could be set externally via activity.stage-updated event
      if (stage) {
        this.value = stage;
        if (!this.stages.find((s) => s.id === stage.id)) {
          this.stages.push(stage);
        }
      }
    },
  },
  created() {
    this.$_activitySummary_config.EventBus.$on(
      "ACTIVITY_FORM_SUBMITTED",
      () => {
        this.showError = true;
      }
    );

    this.$_activitySummary_config.EventBus.$on("UPDATED_INTERNAL_INPUT", () => {
      this.updateForm(this.value);
    });

    this.handleStage();
    this.populateOptions();
  },
  methods: {
    ...mapMutations(["upsertFormData", "setSelectedStage"]),
    handleStage() {
      if (this.activity.stage) {
        this.value = this.activity.stage;
      }
    },
    updateForm(option) {
      this.showError = false;

      const stageId = option ? option.id : null;

      this.upsertFormData({
        id: this.id,
        value: stageId,
        error: this.validate(stageId),
      });
      // If selected stage is null and a value is picked from the dropdown
      // or the selected value is different from the new value.
      if (!this.selectedStage || this.selectedStage.id !== stageId) {
        this.setSelectedStage(option);
      }
    },
    populateOptions() {
      if (!this.stageEnabled) {
        return;
      }

      if (this.selectedProspect.type === "lead") {
        this.retrieveLead().then((lead) => {
          this.value = lead.stage;
          this.retrieveStages("lead", lead.recordType && lead.recordType.id);
        });
      } else if (this.selectedOpportunity) {
        if (this.selectedOpportunity.stage) {
          this.value = this.selectedOpportunity.stage;
        }
        this.retrieveStages(
          "opportunity",
          this.selectedOpportunity.recordType &&
            this.selectedOpportunity.recordType.id
        );
      }
    },
    retrieveLead() {
      return axios
        .get(
          `${this.$_activitySummary_config.jiminnyHost()}/api/v1/crm/leads`,
          {
            params: {
              leadId: this.selectedProspect.crmId,
            },
          }
        )
        .then((response) => response.data)
        .catch((error) => {
          if (axios.isCancel(error)) {
            return;
          }

          console.error(error);
          errorNotification({
            message: error.response.data.error.message,
          }).show();
        });
    },
    retrieveStages(type, recordTypeId) {
      const params = {
        type,
        ...(recordTypeId && { recordTypeId }),
      };

      return axios
        .get(
          `${this.$_activitySummary_config.jiminnyHost()}/api/v1/organizations/${
            this.$_activitySummary_config.getTeam().id
          }/stages`,
          {
            params,
          }
        )
        .then((response) => (this.stages = response.data))
        .catch(console.error);
    },
    reset() {
      this.value = {};
      this.stages = [];
    },
    validate(value) {
      if (this.stageEnabled && !value) {
        return "Please select the stage";
      }
      return null;
    },
  },
};
</script>

<style module lang="less" src="../custom-section/fields/field.less"></style>



// WEBPACK FOOTER //
// select-stage.vue?0bed354d